import { makeStyles } from '@material-ui/core/styles';

import { DOCUMENT_SCORE_PANEL_HEIGHT, DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT } from 'src/data/ui';

const calcPanelTop = ({ middle }, locked) => {
  const height = locked ? DOCUMENT_LOCKED_SCORE_PANEL_HEIGHT : DOCUMENT_SCORE_PANEL_HEIGHT;
  return middle - height / 2;
};

export const useStyles = makeStyles(
  () => ({
    root: ({ boundaries = {}, locked = false }) => ({
      position: 'absolute',
      top: calcPanelTop(boundaries, locked),
    }),
  }),
  { name: 'DocumentScoreContainer' }
);
